/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { campaignOverviewSchema } from '../campaign-schema';

export const getCampaignOverviewPathSchema = z.object({
  campaignId: z.string(),
});

export const getCampaignOverviewOperationResponseSchema =
  campaignOverviewSchema;

export type GetCampaignOverviewInput = {
  path: z.input<typeof getCampaignOverviewPathSchema>;
  signal?: AbortSignal;
};

export async function getCampaignOverview({
  path,
  signal,
}: GetCampaignOverviewInput): Promise<
  z.infer<typeof getCampaignOverviewOperationResponseSchema>
> {
  const parsedPath = getCampaignOverviewPathSchema.parse(path);

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/overview`,
    {
      signal,
    },
  );
  return getCampaignOverviewOperationResponseSchema.parse(
    await response.json(),
  );
}
